import { SVGProps } from 'react'

const StarsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="140"
      height="138"
      viewBox="0 0 150 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M54.584 0.0103302C54.4954 0.246666 53.9932 2.63955 53.491 5.32784C47.9666 33.6879 41.3493 43.0527 22.4426 49.2269C18.159 50.6153 11.6008 52.2401 5.3379 53.4809C2.6496 53.9831 0.256722 54.4853 0.0203877 54.5739C-0.215946 54.6626 2.11785 55.2534 5.19019 55.8738C24.0969 59.7142 33.2253 63.4069 39.6359 69.847C45.8396 76.0508 49.8278 85.8291 53.3137 103.259C53.9045 106.183 54.4658 108.901 54.5545 109.315C54.6726 109.787 55.1748 107.926 56.002 103.85C59.9015 84.8542 63.3579 76.3757 69.8571 69.847C73.9338 65.7703 78.6014 63.082 85.8392 60.5709C89.8568 59.1825 98.808 56.9373 105.248 55.667C107.671 55.2239 109.532 54.7512 109.384 54.633C109.266 54.5444 107.995 54.2194 106.518 53.9536C86.8436 50.2608 76.2972 46.125 69.7685 39.5667C63.5056 33.2743 59.9311 24.6186 56.1793 6.45043C55.3816 2.66909 54.6726 -0.226006 54.584 0.0103302Z"
        fill="#7181FF"
      />
      <path
        d="M114.967 77.7663C114.878 78.4162 113.047 86.7765 112.544 88.7854C111.658 92.2122 110.033 96.4662 108.645 98.8296C104.923 105.27 99.0438 108.519 86.4294 111.237C79.1917 112.803 79.369 112.626 84.0661 113.571C94.967 115.698 101.23 118.238 105.248 122.108C109.324 126.097 111.599 131.473 113.933 142.61C114.494 145.328 114.996 147.573 115.026 147.633C115.085 147.662 115.617 145.269 116.237 142.315C118.659 130.616 121.702 124.206 126.547 120.661C130.565 117.707 136.06 115.639 144.686 113.866C147.64 113.246 150.033 112.714 150.003 112.655C149.944 112.626 147.699 112.123 144.981 111.562C133.844 109.228 128.467 106.954 124.479 102.877C120.639 98.9182 118.246 93.0985 116.119 82.5225C115.262 78.3571 115.026 77.2936 114.967 77.7663Z"
        fill="#7181FF"
      />
    </svg>
  )
}

export default StarsIcon
